module.exports = "/_next/static/images/tm-d55963e2cb1d6f0a57229b106de17db8.svg";